<script src="//code.jquery.com/jquery-1.11.2.min.js"></script>
<script src="js/jquery.csvToTable.js"></script>

<style src="@/assets/css/common.css" scoped></style>

<style>
.window-container {
	max-width: 80%;
	text-align: center;
	margin: 0 auto;
}
.jobinfo-container {
	max-width: 80%;
	text-align: center;
	margin: auto;
	margin-top: 20px;
}

.clusterinfotable {
    border-collapse: separate;
	border-radius: 10px;
	width: 100%
}
.clusterinfotable tbody tr {
	border-top:solid white 3px;
	background-color:#d7e9b5;
	line-height: 50px;
}
.clusterinfotable tbody td {
    background-color:#f3f8e9;	
}
.clusterinfotable tbody td:nth-child(1) {
    text-align: center;
    font-weight: bold;
	background-color:#d7e9b5;
	border-top-left-radius: 10px;
	border-bottom-left-radius: 10px;
}

clusterinfotable tbody tr:last-child td:first-child {
	border: 2px solid orange;
	border-bottom-left-radius: 10px;
	border-radius: 30px;

}

clusterinfotable tbody tr:last-child td:last-child {
	border: 10px solid green;
	border-bottom-right-radius: 10px;
}
.clusterinfotable tbody td:nth-child(2) {
	border-top-right-radius: 10px;
	border-bottom-right-radius: 10px;
}
.display_table {
	width: 100%;
	margin: auto;
	margin-bottom: 10px;
	overflow: auto;
	max-height: 500px;
	border: solid 2px #f3f8e9;
}
table {
	width: 100%;
	margin: auto;
}
table>thead {
	background: #f3f8e9;
	font-weight: bold;
	position: sticky;
	top: 0;
}
th, td {
	padding: 10px;
	text-align: center;
}
</style>
<template>
	<div class="window-container">
		<div class="jobinfo-container">  
	<!-- <vue-csv-import url="result_somatic.txt" :map-fields="['Module_ID', 'Module_size']"></vue-csv-import> -->
			<table class="clusterinfotable" id="Q2">
				<!-- <thead> -->
					<!-- <tr> -->
						<!-- <td>Job name</td> -->
						<!-- <td>Email</td> -->
						<!-- <td>Submission time</td> -->
						<!-- <td>Last refresh</td> -->
					<!-- </tr> -->
				<!-- </thead> -->
				<!-- <tbody> -->
					<!-- <tr> -->
						<!-- <td>{{jobname}}</td> -->
						<!-- <td>{{jobemail}}</td> -->
						<!-- <td>{{new Date(submission_time*1000).toString()}}</td> -->
						<!-- <td>{{new Date(Date.now()).toString()}}</td> -->
						
					<!-- </tr> -->
				<!-- </tbody> -->
				<tbody>
					<!--<tr><td>Job name</td><td>{{jobname}}</td></tr>-->
					<!--<tr><td>Email</td><td>{{jobemail}}</td></tr>-->
					<tr><td>Submission time</td><td>{{new Date(submission_time).toString()}}</td></tr>
					<tr><td>Last refresh</td><td>{{new Date(referesh_time).toString()}}</td></tr>
					<!--<tr><td>Completion time</td><td>{{completion_time===null?"N.A.":new Date(completion_time).toString()}}</td></tr>-->
					<tr><td>Status</td><td>{{job_status}}</td></tr>
					<tr><td>Retrieve this page</td><td>http://netflow3d.yulab.org/#/results/{{token}}<br><b style="color:red;">[IMPORTANT] Please save the link above to retrieve your results. Your results will be kept for 3 days.</b></td></tr>
				</tbody>
				
			</table>	
		</div>
		<br>
		<div v-if="this.token_error">
			<label>Token not found: {{token}} </label>
		</div>
		<div v-else-if="this.result_ready">
			<div class="sec_header" style="margin-bottom:10px;">
				3D clusters & LOF enrichment signals
			</div>		
			<div class="display_table">
				<table id="result_table1">
					<thead>
					<tr>
						<th v-for="(v, index) in mytable1[0]" :key="index">
						{{v}}
						</th>
					</tr>
					</thead>
					<tbody>
						<tr v-for="(k, index) in mytable1.slice(1)" :key="index">
							<td v-for="(v, index2) in k" :key="index2">
								{{v}}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<button class="submit-button" style="margin-bottom:80px;" v-on:click="exportTableToExcel(mytable1, token + '-signatures.tsv')">Download this table</button>
			<div class="sec_header" style="margin-bottom:10px;"> 
				Strongly connected subnetworks
			</div>		
			<div class="display_table">
				<table id="result_table2">
					<thead>
					<tr>
						<th v-for="(v, index) in mytable2[0]" :key="index">
						{{v}}
						</th>
					</tr>
					</thead>
					<tbody>
						<tr v-for="(k, index) in mytable2.slice(1)" :key="index">
							<td v-for="(v, index2) in k" :key="index2">
								{{v}}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<button class="submit-button" style="margin-bottom:80px;" v-on:click="exportTableToExcel(mytable2, token + '-subnetworks.tsv')">Download this table</button>
		</div>
		<div v-else>
			<button class="submit-button" style="margin-bottom:300px;" @click="refresh_result()">Refresh</button>
		</div>
	

	</div>
	<!-- <div> -->
		<!-- <table class="borderedtable" id="Q1"> -->
			<!-- <thead> -->
			<!-- <tr> -->
				<!-- <th>Chain</th><th>Protein</th><th>Coverage</th><th>Covered residues</th> -->
			<!-- </tr> -->
			<!-- </thead> -->
			<!-- <tbody> -->
				<!-- <tr v-for="(u, pdb_chain) in getPDBInfo2" :key="pdb_chain"> -->
					<!-- <div v-if="selectedPDBChains.includes(pdb_chain)"> -->
					<!-- <td style="background-color:#ffeda0">{{pdb_chain}}</td> -->
					<!-- <td style="background-color:#ffeda0">{{u["uniprot_name"]}}</td> -->
					<!-- <td style="background-color:#ffeda0">{{(u["coverage"] * 100).toFixed(1)}}%</td> -->
					<!-- <td style="background-color:#ffeda0">{{u["coveredResidues"]}}</td> -->
					<!-- </div> -->
					<!-- <div v-if="!selectedPDBChains.includes(pdb_chain)"> -->
					<!-- <td>{{pdb_chain}}</td> -->
					<!-- <td>{{u["uniprot_name"]}}</td> -->
					<!-- <td>{{(u["coverage"] * 100).toFixed(1)}}%</td> -->
					<!-- <td>{{u["coveredResidues"]}}</td> -->
					<!-- </div> -->
				<!-- </tr> -->
			<!-- </tbody> -->
		<!-- </table> -->
	<!-- </div>	 -->
</template>
<script>
//import { VueCsvImport } from 'vue-csv-import';
// import $ from 'jquery'
import axios from "axios";
import mylib from '@/view/mylib'

/*new Vue({
    components: { VueCsvImport },
    el: '#app',
});*/

export default {
	name: "Home",
	components: {
	},
	props: ['jobtoken'],
	data() {
		return {
			mytable1: [],
			mytable2: [],
			result_ready: false,
			token_error: false,
			job_status: "N.A.",
			token: this.$route.params.jobtoken,
			jobname: "",
			jobemail: "",
			submission_time: 0, // From Flask
			referesh_time: 0, //From Date.now()
			completion_time: null,
			timer_refresh_result: null,
		};
	},
	created() {
		this.refresh_result();
		this.timer_refresh_result = setInterval(this.timer_refresh_result_func, 5000);

	},
	mounted() {
		document.onreadystatechange = () => {
			if (document.readyState == "complete") {
			/*
			$(function() {
				$('#demo').CSVToTable('result_somatic.txt');
			});
			*/
			}
		}
	},
	destroyed() {
	},
	computed: {
	},
	watch: {
	},
	methods: {
		timer_refresh_result_func() {
			if (this.result_ready || this.token_error) {
				clearInterval(this.timer_refresh_result);
			}
			else {
				this.refresh_result();
			}
		},
		refresh_result() {
			const payload = {
				token: this.token,
			};
			const path = "http://netflow3dapi.yulab.org/retrieve_result";
			console.log(payload);
			console.log(document.location.href)
			axios
				.post(path, payload)
				.then(res => {
					switch(res.data.status) {
						case "ready":
							console.log("Resources request");
							console.log(res.data);
								[this.mytable1, this.mytable2] = res.data.result;
								console.log(this.mytable);
								console.log(this.token);
							this.result_ready = true;
							this.token_error = false;
							this.job_status = "Complete";
							this.jobname = res.data.jobname;
							this.jobemail = res.data.jobemail;
							this.submission_time = res.data.submission_time * 1000;
							//this.completion_time = res.data.completion_time * 1000;
							break;
						case "pending":
						case "running":
							this.result_ready = false;
							this.token_error = false;
							this.job_status = "In Progress";
							this.jobname = res.data.jobname;
							this.jobemail = res.data.jobemail;
							this.submission_time = res.data.submission_time * 1000;
							break;
						case "error":
						case "token_not_found":
							this.result_ready = false;
							this.token_error = true;
							this.job_status = "Error";
							//alert("Failure: " + res.data.status)
					}
					this.referesh_time = Date.now();
				})
				.catch(error => {
					this.showError = true;
					console.log(error);
				});		
		},
		exportTableToExcel(selectedTable, filename = ''){
			
			var downloadLink;
			var dataType = 'application/vnd.ms-excel';
			var csvContent = "data:text;charset=utf-8,";
			selectedTable.forEach(function(rowArray){
				csvContent += rowArray.join("\t") + "\n";
			});
			var tableHTML = csvContent;
			// Create download link element
			downloadLink = document.createElement("a");

			document.body.appendChild(downloadLink);
			
			if(navigator.msSaveOrOpenBlob){
			var blob = new Blob(['\ufeff', tableHTML], {
			type: dataType
			});
			navigator.msSaveOrOpenBlob( blob, filename);
			}else{
			// Create a link to the file
			downloadLink.href = tableHTML;

			// Setting the file name
			downloadLink.download = filename;

			//triggering the function
			downloadLink.click();
			}
		},
		
	},
};
</script>

<style src="@/assets/css/Advanced.css" scoped></style>
<style scoped>
.query-form-title {
	background-color: #eeeeee;
	text-align: center;
	padding-top: 5px;
	padding-right: 5px;
	padding-bottom: 5px;
	padding-left: 10px;
	font-weight: bold;

}
.snapshot_canvas {
	width: 100%;
	height: 100%;
}
.advance-options-form {
  border: 1px solid #000000;
	padding-top: 10px;
	padding-right: 10px;
	padding-bottom: 10px;
	padding-left: 10px;
}
.borderedtable {
		/*border-left: 1px solid black;*/
	/*border: 1px solid black;*/
	z-index:3;
}
.borderedtable thead tr {
	/*border-top: 2px solid black;*/
	/*box-shadow: 0 -1px 0 #000;*/
	/*outline: 1px solid black;*/
	/*border-bottom: 2px solid black*/
}

.borderedtable tbody tr td {
	border-bottom: 1px solid black
}
.borderedtable thead tr th:first-child,
.borderedtable tbody tr td:first-child  {
/*
	width: 6em;
	min-width: 6em;
	max-width: 6em;
	*/
}
.borderedtable thead tr th,
.borderedtable tbody tr td {
	white-space: nowrap;
	text-align: left;
}

</style>
